import React from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getProcedureUIString, {
  ProceduresStringKeys,
  StringCase,
  getProcedureRunUIString,
} from 'procedures/ProceduresStringKeys';
import getTestProps from 'test/lib/cypress/getTestProps';
import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';
import {ButtonStyle} from 'ui-library/buttons/Button';

export interface PublishedProcedureVersionUpdateBannerProps {
  procedureType: ProcedureType;
  onOpenUpdateModal: () => void;
}

/**
 * Banner displayed when a procedure run plan's procedure has a newer published version available.
 * Blocks creating a run until the template version is updated.
 */
export default function PublishedProcedureVersionUpdateBanner({
  procedureType,
  onOpenUpdateModal,
}: PublishedProcedureVersionUpdateBannerProps): JSX.Element {
  const procedureString = getProcedureUIString(ProceduresStringKeys.PROCEDURE, procedureType, {
    stringCase: StringCase.LOWER,
  });
  const procedureRunString = getProcedureRunUIString(procedureType, {
    stringCase: StringCase.LOWER,
    prependAorAn: true,
  });

  return (
    <div {...getTestProps({component: 'PublishedProcedureVersionUpdateBanner', element: 'root'})}>
      <InlineBanner
        bannerType={InlineBannerType.ERROR}
        text={`This ${procedureString} is outdated. Update to the latest version to create ${procedureRunString}.`}
        action={{
          actionType: InlineBannerActionType.CUSTOM,
          actionText: 'Update',
          actionOnClick: onOpenUpdateModal,
          buttonStyle: ButtonStyle.LINK,
        }}
        dataTestAttrs={{component: 'PublishedProcedureVersionUpdateBanner', element: 'banner'}}
      />
    </div>
  );
}
